module.exports = __webpack_public_path__ + "images/default_avatars/dingtalk-58ed90e3fcede1174ac508d6c72f9dab.png";